module.exports = __webpack_public_path__ + "img/ascenti-logo-white.edde972f.png";